// Types used by the Investigation Tool
export type Question =
  | { id: string; label: string; type: "checkbox" }
  | { id: string; label: string; type: "textarea" }
  | { id: string; label: string; type: "select"; options: string[] };

export type StepConfig = {
  label: string;
  questions: Question[];
};

// Default (base) steps shown to all categories
export const BASE_STEPS: StepConfig[] = [
  {
    label: "Google Search",
    questions: [
      { id: "gs_name_match", label: "Does the business name match?", type: "checkbox" },
      { id: "gs_address_match", label: "Does the business address match?", type: "checkbox" },
      { id: "gs_add_screens", label: "Add screenshots of the Google search:", type: "checkbox" },
    ],
  },
  {
    label: "Website",
    questions: [
      { id: "web_exists", label: "Does business website exist?", type: "checkbox" },
      { id: "web_addr_verified", label: "Verified address on business website?", type: "checkbox" },
      { id: "web_add_screens", label: "Add screenshots of the website:", type: "checkbox" },
    ],
  },
  {
    label: "Social Media",
    questions: [
      { id: "sm_matches", label: "Click social links; does name/address match?", type: "checkbox" },
      { id: "sm_add_screens", label: "Add screenshots of the social accounts:", type: "checkbox" },
    ],
  },
  {
    label: "Mobile Outreach",
    questions: [{ id: "called_hours", label: "Called the business and confirmed their hours.", type: "checkbox" }],
  },
  {
    label: "Confirm Case Creation",
    questions: [
      { id: "case_ready", label: "Case has been created and is ready for review.", type: "checkbox" },
      { id: "case_add_screens", label: "Add screenshots of the case creation process:", type: "checkbox" },
    ],
  },
];

// Category-specific overlays
export const OVERLAYS_BY_CATEGORY: Partial<
  Record<string, Partial<Record<number, Question[]>>>
> = {
  Closed: {
    0: [
      {
        id: "closed_reason",
        label: "Closure Type",
        type: "select",
        options: ["Permanently closed", "Temporarily closed", "Relocated", "Merged/Acquired"],
      },
    ],
    1: [
      {
        id: "closed_site_evidence",
        label: "Website Evidence of Closure",
        type: "select",
        options: ["Banner/Notice", "404/Removed", "New owner/brand", "Website not found"],
      },
    ],
    3: [
      {
        id: "closed_call_evidence",
        label: "Mobile Evidence of Closure",
        type: "select",
        options: [
          "Phone is disconnected",
          "New business answered",
          "Confirmation that business is still open",
          "Confirmation that business has closed",
        ],
      },
      { id: "closed_call_notes", label: "Notes", type: "textarea" },
    ],
    4: [
      {
        id: "closed_verified_by",
        label: "Closed Verified By",
        type: "select",
        options: [
          "Phone call",
          "Website notice",
          "Google listing",
          "Social media post",
          "In-person visit",
          "One or more of the above",
          "None of the above",
        ],
      },
    ],
  },
};
